export enum AddOnTaxServicesRouteSegment {
  CorporateActionReclaims = 'corporate-action-reclaims',
  SubstantialHoldingsReclaims = 'substantial-holding-reclaims',
  CrossBorderReclaims = 'cross-border-reclaims',
  NonStandardMarketReclaims = 'non-standard-market-reclaims',
  MigrationSupport = 'migration-support',
}
